<template>
    <div v-if="isAdding">
        Selecione o tipo:
        <v-radio-group v-model="type.selected" row>
            <v-radio
                v-for="(item, index) in type.options"
                :key="index"
                :label="item.label"
                :value="item.value">
            </v-radio>
        </v-radio-group>

        <div v-show="type.selected == 'single'">
            <type-single :currentItem="current.single" @change="onChangeSingle" />
        </div>
        <div v-show="type.selected == 'interval'">
            <type-interval :currentItem="current.interval"  @change="onChangeInterval" />
        </div>
        <div v-show="type.selected == 'multiple'">
            <type-multiple :currentItem="current.multiple" @change="onChangeMultiple" />
        </div>

        <div class="flexsplit">
            <v-text-field
                v-model="location"
                label="Localização">
            </v-text-field>
            <v-text-field
                v-model="link"
                label="Link para inscrição">
            </v-text-field>
        </div>

        <div class="fillError" v-if="fillError">Preencha todos os dados!</div>

        <flk-btn @click.native="submit">{{ isEditing?'Editar':'Adicionar' }}</flk-btn>
        <flk-btn @click.native="cancel" color="grey">Cancelar</flk-btn>
    </div>
</template>

<script>
import SingleAdd from './UpcomingDates_Add_Single';
import IntervalAdd from './UpcomingDates_Add_Interval';
import MultipleAdd from './UpcomingDates_Add_Multiple';
import Button from '../../../components/Main/Content/Button/Button';

export default {
    components: {
        'type-single': SingleAdd,
        'type-interval': IntervalAdd,
        'type-multiple': MultipleAdd,
        'flk-btn': Button
    },
    props: [ 'value', 'currentItem' ],
    data() {
        return {
            /**
             * all: Type, Begin
             * single : EventTime
             * interval : End, EventTime
             * multiple : Days { Date, EventTime }, SameTime
             */
            type: {
                selected: 'single',
                options: [
                    { label: 'Simples', value: 'single' },
                    { label: 'Intervalo', value: 'interval' },
                    { label: 'Multiplos dias', value: 'multiple' }
                ]
            },
            location: '',
            link: '',
            current: {
                single: {},
                interval: {},
                multiple: []
            },
            isEditing: false,
            fillError: false
        }
    },
    computed: {
        isAdding: {
            get() {
                return this.value;
            },
            set( value ) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        resetCurrent() {
            this.current = {
                single: {},
                interval: {},
                multiple: []
            },
            this.type.selected = 'single';
            this.link = '';
            this.location = '';
        },
        cancel() {
            this.fillError = false;
            this.isAdding = false;
            this.resetCurrent();
        },
        onChangeSingle(value) {
            this.current.single = value;
        },
        onChangeInterval(value) {
            this.current.interval = value;
        },
        onChangeMultiple(value) {
            this.current.multiple = value;
        },
        edit( value ) {
            this.isEditing = true;

            const link = value.link;
            this.link = link;

            if( typeof value.location == "undefined" ) this.location = this.$store.state.course.data.location;
            else this.location = value.location;

            const type = value.type;
            this.type.selected = type;

            if( type == 'single' ) {
                this.current.single = {
                    date: value.data.date,
                    time: value.data.time,
                    timeEnd: value.data.timeEnd
                }
            } else if ( type == 'interval' ) {
                this.current.interval = {
                    date: value.data.date,
                    dateEnd: value.data.dateEnd,
                    time: value.data.time,
                    timeEnd: value.data.timeEnd
                }
            } else {
                this.current.multiple.data = value.data;
            }

            this.isAdding = true;
        },
        submit(){
            const value = {
                type: this.type.selected,
                link: this.link,
                location: this.location,
                data: this.current[this.type.selected]
            };
            this.fillError = false;
            if( value.link == '' ){
                this.fillError = true;
            }
            if( value.type == 'multiple' )
            {
                if( !value.data.length ) this.fillError = true;
                else {
                    value.data.forEach(el => {
                        if(
                            !el.date ||
                            !el.time ||
                            !el.timeEnd
                        ){
                            this.fillError = true;
                        }
                    });
                }
            } else {
                if(
                    !value.data.date ||
                    !value.data.time ||
                    !value.data.timeEnd
                ){
                    this.fillError = true;
                }
                if( value.type == 'interval' && !value.data.dateEnd ) this.fillError = true;
            }

            if( this.fillError ) return;

            this.$emit( this.isEditing?'edit':'add', value );

            this.isEditing = false;
            this.isAdding = false;

            this.resetCurrent();
        }
    }
}
</script>

<style lang="scss">
.fillError {
    font-weight: 700;
    color: #dd0000;
    padding-bottom: 10px;
}
</style>